import { Box, Flex } from '@chakra-ui/react'
import { gynSubTabs } from '@hb/shared'
import { useCallback, useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { SidebarSubtabs } from './SidebarSubtabs'

export const GynDesktopTabs = ({ mobileLayout: _ }: { mobileLayout: boolean }) => {
  const { goTo: onTabSelect, subTab } = useProfile()
  const selectedTab = useMemo(() => subTab?.path ?? 'profile', [subTab])
  const handleSelect = useCallback(
    (updated: string) => {
      onTabSelect({ entity: { type: 'patient' }, tab: `gyn/${updated}` })
    },
    [onTabSelect],
  )

  return (
    <Flex flexFlow="column" w="auto">
      <Box minH="0" flex={1}>
        <SidebarSubtabs subTabs={gynSubTabs} selectedTab={selectedTab} onSelect={handleSelect} />
      </Box>
    </Flex>
  )
}
